export default "__VITE_ASSET__CCDzwTZY__"